import type { NumberPredicate } from '@/components/tree-dnd/tree-dnd-types';
import { useI18nContext } from '@/i18n/i18n-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface NumberPredicateControlProps {
  value: NumberPredicate;
  onChange: (value: NumberPredicate) => void;
}

type NumberPredicateKind = NumberPredicate['kind'];

export function NumberPredicateControl({
  value,
  onChange,
}: NumberPredicateControlProps) {
  const { LL } = useI18nContext();

  return (
    <div className="flex flex-col gap-3">
      <Select
        value={value.kind}
        onValueChange={(kind) =>
          onChange({ kind: kind as NumberPredicateKind, value: value.value })
        }
      >
        <SelectTrigger className="h-8 w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="exact">
            {LL.audiences.filters.number.exact()}
          </SelectItem>
          <SelectItem value="atLeast">
            {LL.audiences.filters.number.atLeast()}
          </SelectItem>
          <SelectItem value="atMost">
            {LL.audiences.filters.number.atMost()}
          </SelectItem>
        </SelectContent>
      </Select>

      <Input
        type="number"
        min={0}
        className="h-8 w-full"
        value={value.value}
        onChange={(event) => {
          const nextValue = Math.max(0, Number(event.target.value) || 0);
          onChange({ ...value, value: nextValue });
        }}
      />
    </div>
  );
}
